export const getWhiteBlackListedStore = <T>(
    store: T,
    whitelist?: (keyof T)[],
    blacklist?: (keyof T)[],
): T => {
    if (!store || typeof store !== 'object' || (!whitelist && !blacklist)) {
        return store;
    }
    const passWhiteBlackList = (key: keyof T): boolean => {
        if (whitelist && whitelist.indexOf(key) === -1) {
            return false;
        }

        return !blacklist || blacklist.indexOf(key) === -1;
    };

    return Object.entries(store).reduce<T>((acc, [key, value]) => {
        if (passWhiteBlackList(key as keyof T)) {
            acc[key as keyof T] = value;
        }

        return acc;
    }, {} as T);
};
